<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col>
        <h1 class="text-center mb-5">Welcome to Pjili!</h1>

        <v-card class="mx-auto" max-width="400" outlined>
          <v-alert v-if="hasErrors()" color="warning">
            <ul>
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </v-alert>

          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline text-center mb-1">Account recovery</v-list-item-title>
              <v-list-item-subtitle
                class="text-center mb-1"
              >Please provide your email for instructions.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-form @keyup.native.enter="getRecovery()">
              <v-text-field
                v-model="Email"
                name="Email"
                label="Email"
                prepend-icon="mdi-account-circle"
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn to="/" rounded outlined color="grey" dark>Sign in instead</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.prevent="getRecovery()" rounded :loading="loading" color="info">Next</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "AccountRecovery",
  data() {
    return {
      Email: "",
      loading: false,
      errors: [],
    };
  },
  computed: {},
  methods: {
    getRecovery() {
      this.loading = true;
      this.$axios
        .post("/account-recovery", { Email: this.Email })
        .then(() => {
          this.loading = false;
          this.$store.dispatch("addNotification", {
            type: "success",
            message:
              "We have sent an email with instructions, Hope to see you soon.",
          });
          this.errors = [];
          this.$router.push({ name: "login" });
        })
        .catch((error) => {
          if (!error.response) {
            this.errors = ["Network Error"];
          } else if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          } else {
            this.errors = ["Unknown Error"];
          }
          this.loading = false;
        });
    },
    hasErrors() {
      return this.errors.length > 0;
    },
  },
};
</script>